import type { GoalHit } from '@/goals/goal_types'

// A goal aligned to several grades carries a ref per grade, and goals share standards, so each
// standard is listed once.
export function uniqueStandardRefsForSetFromHits(hits: Pick<GoalHit, 'standard_set_refs'>[], setCode: string): string[] {
  if (!setCode) {
    return []
  }
  const refsInSet = hits.flatMap((hit) => hit.standard_set_refs ?? []).filter((ref) => ref.standard_set_code === setCode)
  const longRefs = refsInSet.map((ref) => ref.standard_long_ref)
  return [...new Set(longRefs)]
}
